<template>
    <Dialog 
      v-bind="$attrs"
      v-on="$listeners">
      <template #content>
        <v-alert
          outlined  
          prominent
          :type="type"
          :elevation="elevation"
        >
          <slot></slot>
        </v-alert>
      </template>
      <template #footer>
          <v-btn
            color="error"
            depressed
            @click="$emit('on-cancel')"
          >
            Não
          </v-btn>
          <v-btn
            color="primary"
            depressed
            @click="OnSubmit"
            :disabled="disableButton"
          >
            Sim
          </v-btn>
      </template>
    </Dialog>
</template>

<script>
  import Dialog from '@/components/UI/Modals/Dialog.vue';
  export default {
    name: 'uiDialogConfirmation',
    props: {
      type: {
        type: String,
        default: 'info'
      },
      elevation:{
        type: Number,
        default: 2
      }
    },
    data(){
      return{
        disableButton: false,
      }
    },
    components: {
      Dialog
    },
    methods:{
      OnSubmit(){
        this.disableButton = true
        this.$emit('on-submit')
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>